// extracted by mini-css-extract-plugin
export var grid = "pictureLift-module--grid--2i-zM";